<template>
    <div class="home-component">
        <div class="app-header">
            <img class="session-detail-component-header-logo" src="./../assets/elevate-logo.png" alt="Elevate logo" height="120">
        </div>

        <div class="enter-membership-form">
                <div class="membership-input">
                    

               <label class="waiver-check-box-container">
                    <input type="checkbox" name="waiver-check-box" id="waiver-check-box"/>
                    <a href=https://drive.google.com/file/d/1x4XHllkC_oeM6yzY6rc5jl_uoAro8auw/view?usp target=“_blank” class="waiver-link">私はELEVATE</a> の利用規約に同意します。<br> <br>
                        
                </label>

                <label class="marketing-check-box-container">
                    <input type="checkbox" name="marketing-check-box" id="marketing-check-box"/>
                    ELEVATEがマーケティング資料として自身の写真やビデオを使用することを許可する(任意)。
                </label>
            </div>
            
            <button type="button" @click="showFinalScreen()" class="membership-number-submit">Submit</button>
        </div>
        
    </div>
</template>

<style scoped>
    .home-component {
        min-height: calc(100vh - 110px);
        display: flex;
        align-items: center;
        justify-content: top;
        flex-direction: column;
        background: rgb(34, 32, 37);
        padding-top: 50pt;
        background-image: url("./../assets/elevate-tiling.png");
    }

    .session-detail-component-header-logo {
        width: 100%;
        height: 100pt;
        object-fit: contain;
    }

    .waiver-link {
        color: white;
        font-family:  SFPRoRegular;
        font-size: 14pt;
    }

    .app-header {
        height: 100pt;
        display: flex;
        justify-content: left;
        align-items: left;
        margin-bottom: 35px;
    }

    .enter-membership-form {
        align-items: center;
        justify-content: center;
        max-width: 400px;
        margin-left: 20px;
        margin-right: 20px;
        display: flex;
        flex-direction: column;
    }

    .waiver-check-box-container {
        font-family:  SFPRoRegular;
        font-size: 14pt;
        color: white;
        /* padding-bottom: 16px; */
        margin-bottom: 16px;
    }

    .marketing-check-box-container {
        font-family:  SFPRoRegular;
        font-size: 14pt;
        color: white;
        margin-bottom: 16px;
    }

    .home-component-elevate-title {
        font-family: SFPRoBold;
        font-size: 16pt;
    }

    .membership-number-text-field-label {
        font-family: SFPRoBold;
        color: white;
        padding-top: 25pt;
    }

    .membership-number-text-field {
        width: 100%;
        margin-bottom: 2pt;
        margin-top: 6pt;
    }

    .membership-number-text-field-sub-label {
        font-family: SFPRoRegular;
        color: white;
        font-size: 10pt;
        margin-bottom: 20pt;
    }

    .membership-number-submit {
    margin-top: 40px;
    height: 40px;
    background-color: rgb(225, 228, 99);
    cursor: pointer;
    border: none;
    border-radius: 8px;
    color: black;
    font-family: SFPRoBold;
    font-size: 16px;
    transition: 300ms;
    width: 150pt
}

</style>


<script setup>
    import { store } from '../store.js'
    import { useRouter } from "vue-router";
    const router = useRouter();

    function showFinalScreen() { 
        const waiver = document.getElementById("waiver-check-box").checked;

        if (!waiver) {
            alert("手続きを進めるには、利用規約に同意する必要があります。");
            return
        }

        const allowsPhotos = document.getElementById("marketing-check-box").checked;

        store.updateAllowsPhotos(allowsPhotos);

        router.push('summary');
    } 
</script>

<script>
export default {
    mounted () {
        window.scrollTo(0, 0);
    }
}
</script>